/* istanbul ignore file */

'use client';

import { useFeatureFlagOn } from '@bss-portfolio-view-ui/shared-common-feature-feature-flags';
import { useDatadogRum, UseDatadogRumOptions } from './use-datadog-rum';

export type DatadogRumProps = Omit<UseDatadogRumOptions, 'isReady'> & { sessionReplayFeatureFlagName: string };

export const DatadogRum = ({ sessionReplayFeatureFlagName, ...rest }: DatadogRumProps) => {
  const { enabled: isSessionReplayEnabled } = useFeatureFlagOn(sessionReplayFeatureFlagName);

  useDatadogRum({ isSessionReplayEnabled, ...rest });

  return null;
};
